/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Address,
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
} from './';

/**
 * 
 * @export
 * @interface Interface
 */
export interface Interface {
    /**
     * 
     * @type {number}
     * @memberof Interface
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Interface
     */
    device: string;
    /**
     * 
     * @type {Array<Address>}
     * @memberof Interface
     */
    readonly addresses: Array<Address>;
    /**
     * 
     * @type {number}
     * @memberof Interface
     */
    speed?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Interface
     */
    mtu?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Interface
     */
    useForMounts?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Interface
     */
    priority?: number;
    /**
     * 
     * @type {string}
     * @memberof Interface
     */
    port?: string | null;
}

export function InterfaceFromJSON(json: any): Interface {
    return InterfaceFromJSONTyped(json, false);
}

export function InterfaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Interface {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'device': json['device'],
        'addresses': ((json['addresses'] as Array<any>).map(AddressFromJSON)),
        'speed': !exists(json, 'speed') ? undefined : json['speed'],
        'mtu': !exists(json, 'mtu') ? undefined : json['mtu'],
        'useForMounts': !exists(json, 'use_for_mounts') ? undefined : json['use_for_mounts'],
        'priority': !exists(json, 'priority') ? undefined : json['priority'],
        'port': !exists(json, 'port') ? undefined : json['port'],
    };
}

export function InterfaceToJSON(value?: Interface | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'device': value.device,
        'speed': value.speed,
        'mtu': value.mtu,
        'use_for_mounts': value.useForMounts,
        'priority': value.priority,
        'port': value.port,
    };
}


